import apiService from 'src/shared/config/apiService';
import { ExampleItem } from 'src/shared/types/exampleItem';
import handleAxiosError from 'src/shared/utils/handleAxiosError';

const getProductSamplingExampleItems = async (id: string) => {
  try {
    const response = await apiService.get<ExampleItem[]>(
      `/products/${id}/example-items`
    );

    return response;
  } catch (error) {
    throw handleAxiosError(error);
  }
};

export default getProductSamplingExampleItems;
